import { ShoppingCart, Receipt, Building2, FileText, CalendarCheck, Banknote, UserPlus, FileSpreadsheet, Package, Camera } from 'lucide-react';

/**
 * Quick-action shortcuts rendered by `QuickActionsWidget` on the dashboard.
 * Each entry is filtered at render time by `hasPermission(perm)`.
 */
export const QUICK_ACTIONS = [
  { id: 'add_sale', label: 'Record Sale', labelAr: 'تسجيل بيع', icon: ShoppingCart, path: '/quick-entry', color: 'bg-success hover:bg-success', perm: 'sales' },
  { id: 'add_expense', label: 'Add Expense', labelAr: 'إضافة مصروف', icon: Receipt, path: '/quick-entry', color: 'bg-error hover:bg-error', perm: 'expenses' },
  { id: 'pay_supplier', label: 'Pay Supplier', labelAr: 'دفع مورد', icon: Building2, path: '/suppliers', color: 'bg-info hover:bg-info', perm: 'suppliers' },
  { id: 'new_invoice', label: 'New Invoice', labelAr: 'فاتورة جديدة', icon: FileText, path: '/invoices/new', color: 'bg-orange-500 hover:bg-orange-600', perm: 'invoices' },
  { id: 'approve_leave', label: 'Approve Leave', labelAr: 'اعتماد إجازة', icon: CalendarCheck, path: '/leave-approvals', color: 'bg-purple-500 hover:bg-purple-600', perm: 'employees' },
  { id: 'pay_salary', label: 'Pay Salary', labelAr: 'دفع راتب', icon: Banknote, path: '/employees', color: 'bg-teal-500 hover:bg-teal-600', perm: 'employees' },
  { id: 'add_customer', label: 'Add Customer', labelAr: 'إضافة عميل', icon: UserPlus, path: '/customers', color: 'bg-indigo-500 hover:bg-indigo-600', perm: 'customers' },
  { id: 'view_reports', label: 'View Reports', labelAr: 'عرض التقارير', icon: FileSpreadsheet, path: '/reports', color: 'bg-warning hover:bg-warning', perm: 'reports' },
  { id: 'stock_entry', label: 'Stock Entry', labelAr: 'إدخال مخزون', icon: Package, path: '/stock', color: 'bg-cyan-500 hover:bg-cyan-600', perm: 'stock' },
  { id: 'cctv_view', label: 'CCTV Live', labelAr: 'كاميرات مباشر', icon: Camera, path: '/cctv', color: 'bg-stone-600 hover:bg-stone-700', perm: 'branches' },
];

/**
 * Default GridLayout positions for every dashboard widget keyed by `i`.
 * Saved overrides live in localStorage under `dashboard_layout`.
 */
export const DEFAULT_LAYOUT = [
  { i: 'stats', x: 0, y: 0, w: 12, h: 4, minW: 6 },
  { i: 'quickActions', x: 0, y: 4, w: 12, h: 3, minW: 6 },
  { i: 'budgetAlerts', x: 0, y: 7, w: 6, h: 4, minW: 4 },
  { i: 'complianceHealth', x: 6, y: 7, w: 6, h: 4, minW: 4 },
  { i: 'recentTransactions', x: 0, y: 11, w: 6, h: 4, minW: 4 },
  { i: 'charts', x: 6, y: 11, w: 6, h: 5, minW: 6 },
  { i: 'lowStock', x: 0, y: 16, w: 6, h: 4, minW: 4 },
  { i: 'peakHours', x: 6, y: 16, w: 6, h: 4, minW: 4 },
  { i: 'customerInsights', x: 0, y: 20, w: 6, h: 4, minW: 4 },
  { i: 'profitTrend', x: 6, y: 20, w: 6, h: 4, minW: 4 },
  { i: 'stockAlertTrends', x: 0, y: 24, w: 12, h: 5, minW: 6 },
  { i: 'cashBank', x: 0, y: 29, w: 12, h: 4, minW: 6 },
  { i: 'paymentMode', x: 0, y: 33, w: 12, h: 4, minW: 6 },
  { i: 'spending', x: 0, y: 37, w: 12, h: 5, minW: 6 },
  { i: 'dues', x: 0, y: 42, w: 12, h: 5, minW: 6 },
];

import { DEFAULT_WIDGETS } from './dashboardConstants';

/** Read user's widget visibility preferences (merged with defaults). */
export function getWidgetPrefs() {
  try {
    return { ...DEFAULT_WIDGETS, ...JSON.parse(localStorage.getItem('dashboard_widgets') || '{}') };
  } catch {
    return DEFAULT_WIDGETS;
  }
}

export function saveWidgetPrefs(prefs) {
  try { localStorage.setItem('dashboard_widgets', JSON.stringify(prefs)); } catch (_) {}
}

export function getLayoutPrefs() {
  try {
    return JSON.parse(localStorage.getItem('dashboard_layout') || 'null') || DEFAULT_LAYOUT;
  } catch {
    return DEFAULT_LAYOUT;
  }
}

export function saveLayoutPrefs(layout) {
  try { localStorage.setItem('dashboard_layout', JSON.stringify(layout)); } catch (_) {}
}
